<template>
    <label :class="{'tw-single-line': single_line}">{{data_source && field_name ? formatNumber(value, display_format) : value}}</label>
</template>

<script>
import { computed } from 'vue'
import { formatNumber } from '../../utils/formatNumber'

export default {
    name: 'tw-label',
    props: {
        text: {
            default: 'label'
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        field_name: {
            type: String,
            default: ''
        },
        single_line: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const value = computed(() => {
            if (props.data_source && props.field_name) {
                let current
                // 可能是数据源对象，也可能是插槽传过来的对象
                if (props.data_source?.datas && Array.isArray(props.data_source?.datas)) {
                    current = props.data_source?.current ?? props.data_source?.datas[0] ?? {}
                } else {
                    current = props.data_source ?? {}
                }
                return current[props.field_name]
            } else {
                return props.text
            }
        })

        const display_format = computed(() => {
            if(props.data_source && props.data_source.columns){
                const column = props.data_source.columns.find(el => el.field_name === props.field_name);

                if(column){
                    return column.display_format ?? null
                }else{
                    return null
                }
            }else{
                return null
            }
        })

        return {
            value,
            display_format,
            formatNumber
        }
    }
}
</script>

<style>

</style>